export const QUERY_KEYS = {
    folders: (page, q) => ['customer_file_drop', 'folders', page, q !== null && q !== void 0 ? q : ''],
    files: (folderId, page, search) => ['customer_file_drop', 'files', folderId, page, search !== null && search !== void 0 ? search : ''],
    allowlistUsers: (search, page) => ['customer_file_drop', 'allowed_users', search !== null && search !== void 0 ? search : '', page !== null && page !== void 0 ? page : 1]
};
